import { connect } from 'react-redux';

import RegisterForm from './RegisterForm.js';
import { redux as apiRedux } from '../api';

const mapStateToProps = state => {
  return {
    user: state.api.user,
  };
};

const mapDispatchToProps = dispatch => {
  const { setUserInfo } = apiRedux.actions;
  return {
    onUserInfoUpdated: user => {
      dispatch(setUserInfo(user));
    },
  };
};

const ConnectedRegisterForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterForm);

export default ConnectedRegisterForm;
